module.exports = __webpack_public_path__ + "public/img/空闲.f5ba19f1.png";